import {
  Component,
  OnInit,
  HostListener,
  Renderer2
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { lmwBaseRoutes } from '../../routing/route-locales/lmw-base-routes';
import { HelpCms } from '../../interfaces/help-cms.interface';
import { lmwAuthLazyLoadedState } from '../../../auth-process/common/routing/route-locales/app-routes';
import { signInLazyLoaded } from '../../../auth-process/sign-in/routing/route-locales/sign-in-routes';
import { signInUsernameState } from '../../../auth-process/sign-in/routing/sign-in.states';
import { registrationLazyLoaded } from '../../../auth-process/registration/routing/route-locales/registration-routes';

@Component({
  selector: 'lmw-base-help',
  templateUrl: './help.component.html',
})
export class HelpComponent implements OnInit {
  public browseAllSubjectsLink: string = lmwBaseRoutes.browseSubjectsStatePath;
  public reportAnIssueLink: string = lmwBaseRoutes.reportAnIssueStatePath;
  public helpLink: string = lmwBaseRoutes.helpStatePath;
  public isMobile = true;
  public helpCms: HelpCms;
  public mobileBackButtonText = lmwBaseRoutes.homeLinkText;
  public registrationLink = `/${lmwAuthLazyLoadedState.path}/${registrationLazyLoaded.path}`;
  public signInUsernamePath = `/${lmwAuthLazyLoadedState.path}/${signInLazyLoaded.path}/${signInUsernameState.path}`;
  public userSignedIn = false;
  
  private nonMobileSize = 640;

  constructor(private renderer: Renderer2, private route: ActivatedRoute) {
    if (window.innerWidth > this.nonMobileSize) {
      this.isMobile = false;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (event.target.innerWidth > this.nonMobileSize) {
      this.isMobile = false;
    } else {
      this.isMobile = true;
    }
  }

  ngOnInit(): void {
    this.helpCms = this.route.snapshot.data.cmsData;
    this.userSignedIn = this.route.snapshot.data.userSignedIn;
  }

  public clickAccordionButton(button: HTMLElement) {
    const panel = this.renderer.nextSibling(button);
    if (!panel.style.maxHeight) {
      this.openPanel(panel);
      this.manageButtonState(button, 'active');
    } else {
      this.closePanel(panel);
      this.manageButtonState(button, 'inactive');
    }
  }

  private openPanel(panel) {
    this.renderer.setStyle(panel, 'display', 'block');
    this.renderer.setStyle(panel, 'maxHeight', panel.scrollHeight + 'px');
  }

  private closePanel(panel) {
    this.renderer.removeStyle(panel, 'maxHeight');
  }

  private manageButtonState(selectedButton, state) {
    state === 'active' ? this.renderer.addClass(selectedButton, 'active') : this.renderer.removeClass(selectedButton, 'active');
  }
}
